import { defaultBillingAccountId, preRecurringBillingAccountId } from "@/mock-api/data/billingAccountIds.ts";
import type { BillingAccountInvoice } from "@warrenio/api-spec/spec.oats.gen";

export const defaultBillingAccountFirstInvoiceId = 3786540;

// Excessive detail for mock data, make these empty
const EMPTY_SNAPSHOT = "{}";
const EMPTY_ADDITIONAL_DATA = "{}";

export const cloudServicesInvoice: BillingAccountInvoice = {
    account_snapshot: EMPTY_SNAPSHOT,
    billing_account_id: defaultBillingAccountId,
    created: 1638316799,
    discount_percentage: 0,
    due_date: 1639640904,
    id: 3784695,
    padded_id: "003784695",
    document_number: "#003784695",
    period_end: 1638316799,
    period_start: 1635724800,
    precalc_credit: -20.46,
    precalc_discount_amount: 0,
    precalc_subtotal: 20.46,
    precalc_total: 0,
    precalc_total_before_tax: 0,
    precalc_vat_tax: 0,
    has_record_level_discount: false,
    records_list: [
        {
            amount: 1.36764,
            created: 1638517704,
            descr: "TODO",
            id: 57585,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.04716,
            name: "ubuntu, 4 CPUs, 8 GB RAM",
            qty: 29,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 0.442,
            created: 1638517704,
            descr: "TODO",
            id: 57586,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.0085,
            name: "ubuntu, 1 CPU, 1 GB RAM",
            qty: 52,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 2.16,
            created: 1638517704,
            descr: "TODO",
            id: 57587,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.003,
            name: "ubuntu, 30 GB main storage",
            qty: 720,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 0.72,
            created: 1638517704,
            descr: "TODO",
            id: 57588,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.001,
            name: "ubuntu, 10 GB additional storage",
            qty: 720,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 0.857736,
            created: 1638517704,
            descr: "TODO",
            id: 57589,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.000034,
            name: "ubuntu, backups",
            qty: 25080,
            qty_unit: "GBh",
            vat_amount: 0,
        },
        {
            amount: 2.16,
            created: 1638517704,
            descr: "TODO",
            id: 57590,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.0001,
            name: "ubuntu, snapshots",
            qty: 21600,
            qty_unit: "GBh",
            vat_amount: 0,
        },
        {
            amount: 0.952,
            created: 1638517704,
            descr: "TODO",
            id: 57591,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.017,
            name: "windows 2016, 2 CPUs, 2 GB RAM",
            qty: 56,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 2.88,
            created: 1638517704,
            descr: "TODO",
            id: 57592,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.004,
            name: "windows 2016, 40 GB main storage",
            qty: 720,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 0.069,
            created: 1638517705,
            descr: "TODO",
            id: 57593,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.001,
            name: "windows 2016, 10 GB additional storage",
            qty: 69,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 7.8912,
            created: 1638517705,
            descr: "TODO",
            id: 57594,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.01096,
            name: "windows 2016, Windows license",
            qty: 720,
            qty_unit: "h",
            vat_amount: 0,
        },
        {
            amount: 0.276,
            created: 1638517705,
            descr: "TODO",
            id: 57595,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.0001,
            name: "windows 2016, snapshots",
            qty: 2760,
            qty_unit: "GBh",
            vat_amount: 0,
        },
        {
            amount: 0.682192,
            created: 1638517705,
            descr: "TODO",
            id: 57596,
            invoice_id: 3784695,
            is_technical: false,
            item_price: 0.00274,
            name: "Unassigned floating IP 176.112.148.35",
            qty: 249,
            qty_unit: "h",
            vat_amount: 0,
        },
    ],
    status: 10,
    totals: {
        subtotal_resource_usage: 20.46,
        subtotal: 20.46,
        discount_amount: -0,
        credit: -20.46,
        total_before_tax: 0,
        vat_tax: 0,
        total: 0,
    },
    transaction_list: [
        {
            amount: 0,
            created: 1698157465,
            id: 15386,
            is_success: true,
        },
    ],
    type: "cloud_services",
    document_type: "invoice",
    vat_percentage: 20,
};

export const cloudServicesReport: BillingAccountInvoice = {
    ...cloudServicesInvoice,
    billing_account_id: preRecurringBillingAccountId,
    id: 3784696,
    padded_id: "003784696",
    document_number: "RP-003784696",
    document_type: "report",
    has_record_level_discount: false,
    records_list: cloudServicesInvoice.records_list.map((_r) => ({ ..._r, invoice_id: 3784696 })),
};

export const creditTopupInvoice: BillingAccountInvoice = {
    account_snapshot: EMPTY_SNAPSHOT,
    billing_account_id: defaultBillingAccountId,
    created: 1636128146,
    discount_percentage: 0,
    due_date: 1637251346,
    id: 3784669,
    padded_id: "003784669",
    document_number: "#003784669",
    period_end: 1636128146,
    period_start: 1636128146,
    precalc_credit: 0,
    precalc_discount_amount: 0,
    precalc_subtotal: 66,
    precalc_total: 79.2,
    precalc_total_before_tax: 66,
    precalc_vat_tax: 13.2,
    has_record_level_discount: false,
    records_list: [
        {
            amount: 66,
            created: 1636128146,
            descr: "Top up for account 129511, including VAT (20%) 13.2 \u20ac",
            id: 56652,
            invoice_id: 3784669,
            is_technical: false,
            item_price: 66,
            name: "Credit top up",
            qty: 1,
            qty_unit: "pc",
            vat_amount: 0,
        },
    ],
    status: 10,
    totals: {
        subtotal_resource_usage: 0,
        subtotal: 66,
        discount_amount: -0,
        credit: -0,
        total_before_tax: 66,
        vat_tax: 13.2,
        total: 79.2,
    },
    transaction_list: [
        {
            additional_data: EMPTY_ADDITIONAL_DATA,
            amount: 79.2,
            created: 1636128147,
            id: 12456,
            identifier: "pi_3JsUs8E0TT1OxJzq1EDJ3GgO",
            is_success: true,
            payment_object_id: 632,
        },
    ],
    type: "credit_topup",
    document_type: "invoice",
    vat_percentage: 20,
};

export const billingAccountInvoicesExample: BillingAccountInvoice[] = [
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1698796799,
        discount_percentage: 0,
        due_date: 1700120711,
        id: defaultBillingAccountFirstInvoiceId,
        padded_id: `00${defaultBillingAccountFirstInvoiceId}`,
        document_number: `#00${defaultBillingAccountFirstInvoiceId}`,
        period_end: 1698796799,
        period_start: 1696118400,
        precalc_credit: -1.99,
        precalc_discount_amount: 0,
        precalc_subtotal: 1.99,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 0.3471,
                created: 1698997511,
                descr: "TODO",
                id: 78232,
                invoice_id: defaultBillingAccountFirstInvoiceId,
                is_technical: false,
                item_price: 0.00534,
                location_slug: "tll",
                name: "Unassigned floating IP 176.112.157.209",
                qty: 65,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 1.63938,
                created: 1698997511,
                descr: "TODO",
                id: 78233,
                invoice_id: defaultBillingAccountFirstInvoiceId,
                is_technical: false,
                item_price: 0.00534,
                location_slug: "tll",
                name: "Unassigned floating IP 176.112.157.196",
                qty: 307,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 1.99,
            subtotal: 1.99,
            discount_amount: -0,
            credit: -1.99,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1696118399,
        discount_percentage: 0,
        due_date: 1697442333,
        id: 3786508,
        padded_id: "003786508",
        document_number: "#003786508",
        period_end: 1696118399,
        period_start: 1693526400,
        precalc_credit: -12.21,
        precalc_discount_amount: 0,
        precalc_subtotal: 12.21,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 0.2349,
                created: 1696319133,
                descr: "TODO",
                id: 77821,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.01566,
                location_slug: "tll",
                name: "test, 1 CPU, 1 GB RAM",
                qty: 15,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 4.25088,
                created: 1696319133,
                descr: "TODO",
                id: 77822,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.01296,
                location_slug: "tll",
                name: "test, 1 CPU, 1 GB RAM",
                qty: 328,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 1.6512,
                created: 1696319133,
                descr: "TODO",
                id: 77823,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.0048,
                location_slug: "tll",
                name: "test, 30 GB main storage",
                qty: 344,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 1.6512,
                created: 1696319133,
                descr: "TODO",
                id: 77824,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB backup",
                qty: 344,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.2592,
                created: 1696319133,
                descr: "TODO",
                id: 77825,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB backup",
                qty: 54,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 1.6512,
                created: 1696319133,
                descr: "TODO",
                id: 77826,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB snapshot",
                qty: 344,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 2.5098,
                created: 1696319133,
                descr: "TODO",
                id: 77827,
                invoice_id: 3786508,
                is_technical: false,
                item_price: 0.00534,
                location_slug: "tll",
                name: "Unassigned floating IP 176.112.157.196",
                qty: 470,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 10,
        totals: {
            subtotal_resource_usage: 12.21,
            subtotal: 12.21,
            discount_amount: -0,
            credit: -12.21,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [
            {
                amount: 0,
                created: 1698157459,
                id: 15385,
                is_success: true,
            },
        ],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1693526399,
        discount_percentage: 0,
        due_date: 1694717711,
        id: 3786419,
        padded_id: "003786419",
        document_number: "#003786419",
        period_end: 1693526399,
        period_start: 1690848000,
        precalc_credit: -4.09,
        precalc_discount_amount: 0,
        precalc_subtotal: 4.09,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 2.72484,
                created: 1693594511,
                descr: "TODO",
                id: 75129,
                invoice_id: 3786419,
                is_technical: false,
                item_price: 0.01566,
                location_slug: "tll",
                name: "test, 1 CPU, 1 GB RAM",
                qty: 174,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.8352,
                created: 1693594511,
                descr: "TODO",
                id: 75131,
                invoice_id: 3786419,
                is_technical: false,
                item_price: 0.0048,
                location_slug: "tll",
                name: "test, 30 GB main storage",
                qty: 174,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.2208,
                created: 1693594511,
                descr: "TODO",
                id: 75133,
                invoice_id: 3786419,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB backup",
                qty: 46,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.3072,
                created: 1693594511,
                descr: "TODO",
                id: 75134,
                invoice_id: 3786419,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB snapshot",
                qty: 64,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 4.09,
            subtotal: 4.09,
            discount_amount: -0,
            credit: -4.09,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1693526399,
        discount_percentage: 0,
        due_date: 1694717688,
        id: 3786404,
        padded_id: "003786404",
        document_number: "#003786404",
        period_end: 1693526399,
        period_start: 1690848000,
        precalc_credit: -4.09,
        precalc_discount_amount: 0,
        precalc_subtotal: 4.09,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 2.72484,
                created: 1693594488,
                descr: "TODO",
                id: 74851,
                invoice_id: 3786404,
                is_technical: false,
                item_price: 0.01566,
                location_slug: "tll",
                name: "test, 1 CPU, 1 GB RAM",
                qty: 174,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.8352,
                created: 1693594488,
                descr: "TODO",
                id: 74852,
                invoice_id: 3786404,
                is_technical: false,
                item_price: 0.0048,
                location_slug: "tll",
                name: "test, 30 GB main storage",
                qty: 174,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.2208,
                created: 1693594488,
                descr: "TODO",
                id: 74853,
                invoice_id: 3786404,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB backup",
                qty: 46,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.3072,
                created: 1693594488,
                descr: "TODO",
                id: 74854,
                invoice_id: 3786404,
                is_technical: false,
                item_price: 0.00016,
                location_slug: "tll",
                name: "test, 30 GB snapshot",
                qty: 64,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 4.09,
            subtotal: 4.09,
            discount_amount: -0,
            credit: -4.09,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1648771199,
        discount_percentage: 0,
        due_date: 1650095148,
        id: 3784936,
        padded_id: "003784936",
        document_number: "#003784936",
        period_end: 1648771199,
        period_start: 1646092800,
        precalc_credit: -2.02,
        precalc_discount_amount: 0,
        precalc_subtotal: 2.02,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 0.0085,
                created: 1648971948,
                descr: "TODO",
                id: 60784,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.0085,
                name: "ubuntu, 1 CPU, 1 GB RAM",
                qty: 1,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.432,
                created: 1648971948,
                descr: "TODO",
                id: 60785,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.003,
                name: "ubuntu, 30 GB main storage",
                qty: 144,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.144,
                created: 1648971948,
                descr: "TODO",
                id: 60786,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.001,
                name: "ubuntu, 10 GB additional storage",
                qty: 144,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.47709,
                created: 1648971948,
                descr: "TODO",
                id: 60787,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.000034,
                name: "ubuntu, backups",
                qty: 13950,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 0.432,
                created: 1648971948,
                descr: "TODO",
                id: 60788,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.0001,
                name: "ubuntu, snapshots",
                qty: 4320,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 0.238,
                created: 1648971948,
                descr: "TODO",
                id: 60789,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.0085,
                name: "debian, 1 CPU, 1 GB RAM",
                qty: 28,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.288,
                created: 1648971949,
                descr: "TODO",
                id: 60790,
                invoice_id: 3784936,
                is_technical: false,
                item_price: 0.002,
                name: "debian, 20 GB main storage",
                qty: 144,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 2.02,
            subtotal: 2.02,
            discount_amount: -0,
            credit: -2.02,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1643673599,
        discount_percentage: 0,
        due_date: 1644997595,
        id: 3784822,
        padded_id: "003784822",
        document_number: "#003784822",
        period_end: 1643673599,
        period_start: 1640995200,
        precalc_credit: -14.63,
        precalc_discount_amount: 0,
        precalc_subtotal: 14.63,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 1.683,
                created: 1643874395,
                descr: "TODO",
                id: 60023,
                invoice_id: 3784822,
                is_technical: false,
                item_price: 0.003,
                name: "ubuntu, 30 GB main storage",
                qty: 561,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.561,
                created: 1643874396,
                descr: "TODO",
                id: 60024,
                invoice_id: 3784822,
                is_technical: false,
                item_price: 0.001,
                name: "ubuntu, 10 GB additional storage",
                qty: 561,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 2.302344,
                created: 1643874396,
                descr: "TODO",
                id: 60025,
                invoice_id: 3784822,
                is_technical: false,
                item_price: 0.000034,
                name: "ubuntu, backups",
                qty: 67320,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 1.683,
                created: 1643874396,
                descr: "TODO",
                id: 60026,
                invoice_id: 3784822,
                is_technical: false,
                item_price: 0.0001,
                name: "ubuntu, snapshots",
                qty: 16830,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 2.244,
                created: 1643874396,
                descr: "TODO",
                id: 60027,
                invoice_id: 3784822,
                is_technical: false,
                item_price: 0.004,
                name: "windows 2016, 40 GB main storage",
                qty: 561,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 6.14856,
                created: 1643874396,
                descr: "TODO",
                id: 60028,
                invoice_id: 3784822,
                is_technical: false,
                item_price: 0.01096,
                name: "windows 2016, Windows license",
                qty: 561,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 14.63,
            subtotal: 14.63,
            discount_amount: -0,
            credit: -14.63,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1640995199,
        discount_percentage: 0,
        due_date: 1642319323,
        id: 3784743,
        padded_id: "003784743",
        document_number: "#003784743",
        period_end: 1640995199,
        period_start: 1638316800,
        precalc_credit: -18.54,
        precalc_discount_amount: 0,
        precalc_subtotal: 18.54,
        precalc_total: 0,
        precalc_total_before_tax: 0,
        precalc_vat_tax: 0,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 2.049,
                created: 1641196124,
                descr: "TODO",
                id: 58928,
                invoice_id: 3784743,
                is_technical: false,
                item_price: 0.003,
                name: "ubuntu, 30 GB main storage",
                qty: 683,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.683,
                created: 1641196124,
                descr: "TODO",
                id: 58929,
                invoice_id: 3784743,
                is_technical: false,
                item_price: 0.001,
                name: "ubuntu, 10 GB additional storage",
                qty: 683,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 2.625534,
                created: 1641196124,
                descr: "TODO",
                id: 58930,
                invoice_id: 3784743,
                is_technical: false,
                item_price: 0.000034,
                name: "ubuntu, backups",
                qty: 76770,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 2.049,
                created: 1641196124,
                descr: "TODO",
                id: 58931,
                invoice_id: 3784743,
                is_technical: false,
                item_price: 0.0001,
                name: "ubuntu, snapshots",
                qty: 20490,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 2.976,
                created: 1641196124,
                descr: "TODO",
                id: 58932,
                invoice_id: 3784743,
                is_technical: false,
                item_price: 0.004,
                name: "windows 2016, 40 GB main storage",
                qty: 744,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 8.15424,
                created: 1641196124,
                descr: "TODO",
                id: 58933,
                invoice_id: 3784743,
                is_technical: false,
                item_price: 0.01096,
                name: "windows 2016, Windows license",
                qty: 744,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 18.54,
            subtotal: 18.54,
            discount_amount: -0,
            credit: -18.54,
            total_before_tax: 0,
            vat_tax: 0,
            total: 0,
        },
        transaction_list: [],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    cloudServicesInvoice,
    cloudServicesReport,
    creditTopupInvoice,
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1636124544,
        discount_percentage: 0,
        due_date: 1637247744,
        id: 3784668,
        padded_id: "003784668",
        document_number: "#003784668",
        period_end: 1636124544,
        period_start: 1636124544,
        precalc_credit: 0,
        precalc_discount_amount: 0,
        precalc_subtotal: 66,
        precalc_total: 79.2,
        precalc_total_before_tax: 66,
        precalc_vat_tax: 13.2,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 66,
                created: 1636124544,
                descr: "Top up for account 129511, including VAT (20%) 13.2 \u20ac",
                id: 56651,
                invoice_id: 3784668,
                is_technical: false,
                item_price: 66,
                name: "Credit top up",
                qty: 1,
                qty_unit: "pc",
                vat_amount: 0,
            },
        ],
        status: 10,
        totals: {
            subtotal_resource_usage: 0,
            subtotal: 66,
            discount_amount: -0,
            credit: -0,
            total_before_tax: 66,
            vat_tax: 13.2,
            total: 79.2,
        },
        transaction_list: [
            {
                additional_data: EMPTY_ADDITIONAL_DATA,
                amount: 79.2,
                created: 1636124546,
                id: 12455,
                identifier: "pi_3JsTw3E0TT1OxJzq1b2KhP8C",
                is_success: true,
                payment_object_id: 632,
            },
        ],
        type: "credit_topup",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1636120952,
        discount_percentage: 0,
        due_date: 1637244152,
        id: 3784667,
        padded_id: "003784667",
        document_number: "#003784667",
        period_end: 1636120952,
        period_start: 1636120952,
        precalc_credit: 0,
        precalc_discount_amount: 0,
        precalc_subtotal: 51,
        precalc_total: 61.2,
        precalc_total_before_tax: 51,
        precalc_vat_tax: 10.2,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 51,
                created: 1636120952,
                descr: "Top up for account 129511, including VAT (20%) 10.2 \u20ac",
                id: 56650,
                invoice_id: 3784667,
                is_technical: false,
                item_price: 51,
                name: "Credit top up",
                qty: 1,
                qty_unit: "pc",
                vat_amount: 0,
            },
        ],
        status: 10,
        totals: {
            subtotal_resource_usage: 0,
            subtotal: 51,
            discount_amount: -0,
            credit: -0,
            total_before_tax: 51,
            vat_tax: 10.2,
            total: 61.2,
        },
        transaction_list: [
            {
                additional_data: EMPTY_ADDITIONAL_DATA,
                amount: 61.2,
                created: 1636120954,
                id: 12454,
                identifier: "pi_3JsT06E0TT1OxJzq1ZA6XWi1",
                is_success: true,
                payment_object_id: 632,
            },
        ],
        type: "credit_topup",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1635724799,
        discount_percentage: 0,
        due_date: 1637048901,
        id: 3784636,
        padded_id: "003784636",
        document_number: "#003784636",
        period_end: 1635724799,
        period_start: 1633046400,
        precalc_credit: 0,
        precalc_discount_amount: 0,
        precalc_subtotal: 14.76,
        precalc_total: 17.71,
        precalc_total_before_tax: 14.76,
        precalc_vat_tax: 2.95,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 0.04716,
                created: 1635925701,
                descr: "TODO",
                id: 56287,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.04716,
                name: "ubuntu, 4 CPUs, 8 GB RAM",
                qty: 1,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.258,
                created: 1635925701,
                descr: "TODO",
                id: 56288,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.003,
                name: "ubuntu, 30 GB main storage",
                qty: 86,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.086,
                created: 1635925702,
                descr: "TODO",
                id: 56289,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.001,
                name: "ubuntu, 10 GB additional storage",
                qty: 86,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.258,
                created: 1635925702,
                descr: "TODO",
                id: 56290,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.0001,
                name: "ubuntu, snapshots",
                qty: 2580,
                qty_unit: "GBh",
                vat_amount: 0,
            },
            {
                amount: 4.964,
                created: 1635925702,
                descr: "TODO",
                id: 56291,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.017,
                name: "windows 2016, 2 CPUs, 2 GB RAM",
                qty: 292,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 2.444,
                created: 1635925702,
                descr: "TODO",
                id: 56292,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.004,
                name: "windows 2016, 40 GB main storage",
                qty: 611,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 6.69656,
                created: 1635925702,
                descr: "TODO",
                id: 56293,
                invoice_id: 3784636,
                is_technical: false,
                item_price: 0.01096,
                name: "windows 2016, Windows license",
                qty: 611,
                qty_unit: "h",
                vat_amount: 0,
            },
        ],
        status: 10,
        totals: {
            subtotal_resource_usage: 14.76,
            subtotal: 14.76,
            discount_amount: -0,
            credit: -0,
            total_before_tax: 14.76,
            vat_tax: 2.95,
            total: 17.71,
        },
        transaction_list: [
            {
                additional_data: EMPTY_ADDITIONAL_DATA,
                amount: 17.71,
                created: 1636623053,
                id: 12467,
                identifier: "pi_3JuZcXE0TT1OxJzq0yJLUAi1",
                is_success: true,
                payment_object_id: 1198,
            },
        ],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1575158399,
        discount_percentage: 0,
        due_date: 1576287149,
        id: 3783227,
        padded_id: "003783227",
        document_number: "#003783227",
        period_end: 1575158399,
        period_start: 1572566400,
        precalc_credit: 0,
        precalc_discount_amount: 0,
        precalc_subtotal: 0.07,
        precalc_total: 0.08,
        precalc_total_before_tax: 0.07,
        precalc_vat_tax: 0.01,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 0.039,
                created: 1575163949,
                descr: "TODO",
                id: 9673,
                invoice_id: 3783227,
                is_technical: false,
                item_price: 0.003,
                name: "ubuntu, 1 CPU, 512 MB RAM, 30 GB disk, stopped",
                qty: 130,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.02314,
                created: 1575163949,
                descr: "TODO",
                id: 9674,
                invoice_id: 3783227,
                is_technical: false,
                item_price: 0.000178,
                name: "nginx, nginx, 0.01 CPU shares, 32 MB RAM, container service",
                qty: 130,
                qty_unit: "ih",
                vat_amount: 0,
            },
        ],
        status: 10,
        totals: {
            subtotal_resource_usage: 0.07,
            subtotal: 0.07,
            discount_amount: -0,
            credit: -0,
            total_before_tax: 0.07,
            vat_tax: 0.01,
            total: 0.08,
        },
        transaction_list: [
            {
                additional_data: EMPTY_ADDITIONAL_DATA,
                amount: 0.5,
                created: 1589882949,
                id: 700,
                identifier: "pi_1GkSNkE0TT1OxJzqMr5YBSxM",
                is_success: true,
                payment_object_id: 632,
            },
        ],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
    {
        account_snapshot: EMPTY_SNAPSHOT,
        billing_account_id: defaultBillingAccountId,
        created: 1572566399,
        discount_percentage: 0,
        due_date: 1573695150,
        id: 3783186,
        padded_id: "003783186",
        document_number: "#003783186",
        period_end: 1572566399,
        period_start: 1569888000,
        precalc_credit: 0,
        precalc_discount_amount: 0,
        precalc_subtotal: 0.06,
        precalc_total: 0.07,
        precalc_total_before_tax: 0.06,
        precalc_vat_tax: 0.01,
        has_record_level_discount: false,
        records_list: [
            {
                amount: 0.012,
                created: 1572571950,
                descr: "TODO",
                id: 9176,
                invoice_id: 3783186,
                is_technical: false,
                item_price: 0.003,
                name: "ubuntu, 1 CPU, 512 MB RAM, 30 GB disk, stopped",
                qty: 40,
                qty_unit: "h",
                vat_amount: 0,
            },
            {
                amount: 0.040584,
                created: 1572571950,
                descr: "TODO",
                id: 9177,
                invoice_id: 3783186,
                is_technical: false,
                item_price: 0.000178,
                name: "nginx, nginx, 0.01 CPU shares, 32 MB RAM, container service",
                qty: 228,
                qty_unit: "ih",
                vat_amount: 0,
            },
        ],
        status: 5,
        totals: {
            subtotal_resource_usage: 0.06,
            subtotal: 0.06,
            discount_amount: -0,
            credit: -0,
            total_before_tax: 0.06,
            vat_tax: 0.01,
            total: 0.07,
        },
        transaction_list: [
            {
                additional_data: '{"id": "N/A"}',
                amount: 0.2,
                created: 1572571955,
                id: 472,
                identifier: "N/A",
                is_success: false,
                payment_object_id: 552,
            },
        ],
        type: "cloud_services",
        document_type: "invoice",
        vat_percentage: 20,
    },
];
